<script>
import { Line, mixins } from "vue-chartjs";
import * as byte_converter from 'byte-converter';
var moment = require("moment");

const { reactiveProp } = mixins;

Chart.defaults.scale.gridLines.display = false; //

export default {
  name: "LineChartGeneric",
  extends: Line,
  mixins: [reactiveProp],
  props: ["chartData", "titulo","max_of_array"],
  data() {

      function getBitrateConvert(bitrate,titulo){
        var converter = byte_converter.converterBase2
        if(titulo == "Histórico Latência"){
          return bitrate + " ms";
        }
        else if(bitrate < 1024 ){
          return bitrate.toFixed(0) + " bit/s"
        }else if( bitrate >= 1024 && bitrate < 1048576){
          return Number.parseInt(converter(bitrate,'B','KB')).toFixed(0) + " Kbps"
        }else if( bitrate >= 1048576 && bitrate <= 1073741824 ){
          return Number.parseInt(converter(bitrate,'B','MB')).toFixed(2)+ " Mbps"
        }else{
          return Number.parseInt(converter(bitrate,'B','MB')).toFixed(2)+ " Mbps"
        }
      }
        if(this.max_of_array && this.max_of_array > 0){
            var max_of_array = Math.max.apply(Math, this.chartData.datasets[0].data)
                var ytick =  {
                  display: true,
                  ticks: {
                    beginAtZero: true,
                    max: this.max_of_array * 1.5
                  }
                }
          }else{
            var titulo = this.titulo
                var ytick =  {
                  display: true,
                  ticks: {
                      callback: function(value, index, values) {
                        return getBitrateConvert(value,titulo) ;
                    },
                    //stepSize: 100000,
                    beginAtZero: true
                  }
                }
          }

            return {
              options: {
                maintainAspectRatio: false,
                layout: {
                  padding: {
                    bottom: 0
                  }
                },
                legend: {
                  display: true,
                  position: "bottom"
                },
                title: {
                  display: true,
                  text: this.titulo
                },
                responsive: true,
                scales: {
                  xAxes: [
                    {
                      ticks: {
                        callback: (value, index, values) => {
                          var x = Math.ceil(values.length / 24);
                          if (index % x == 0){
                            return value;
                          } 
                        }
                      },
                      gridLines: { display: false }
                    }
                  ],
                  yAxes: [
                    ytick
                  ]
                },
                hover: {
                  mode: "nearest",
                  intersect: true
                },
                tooltips: {
                  callbacks: {
                    label: function(tooltipItem, data) {
                      if(data.datasets && data.datasets[tooltipItem.datasetIndex]){
                        var dataset = data.datasets[tooltipItem.datasetIndex];
                        var currentValue = dataset.data[tooltipItem.index];
                        return currentValue;
                      }
                    }
                  },
                  enabled:false
                }
              }
            };
  },
   methods: {
      getBitrateConvert(bitrate,titulo){
        var converter = byte_converter.converterBase2
        if(titulo == "Histórico Latência"){
          return bitrate + " ms";
        }
        else if(bitrate < 1024 ){
          return bitrate.toFixed(0) + " bit/s"
        }else if( bitrate >= 1024 && bitrate < 1048576){
          return Number.parseInt(converter(bitrate,'B','KB')).toFixed(0) + " Kbps"
        }else if( bitrate >= 1048576 && bitrate <= 1073741824){
          return Number.parseInt(converter(bitrate,'B','MB')).toFixed(2)+ " Mbps"
        }else{
          return Number.parseInt(converter(bitrate,'B','GB')).toFixed(2)+ " Gbps"
        }
      }
   },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: () => {
      try {
        this.renderChart(this.chartData, this.options);
      } catch (error) {
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/charts/LineChartGeneric.vue